<template>
  <div class="upload-container">
    <div v-if="filename" class="file-info">Gekozen bestand: {{ filename }}</div>
    <file-picker
      v-model="fileData"
      :label="labelPicker"
      :class-name="[
        { 'md-success': fileData === null },
        { 'md-primary': fileData !== null }
      ]"
      :content-types="contentTypes"
    ></file-picker>
    <md-button
      v-if="fileData !== null"
      native-type="button"
      class="md-success"
      @click.native.prevent="uploadDocument"
      :disabled="disableButton"
      >{{ labelUpload }}</md-button
    >
  </div>
</template>
<script>
import filePicker from "../Files/FilePicker.vue";

export default {
  components: {
    filePicker
  },
  props: ["labelPicker", "labelUpload", "fieldId", "contentTypes"],
  data() {
    return {
      fileData: {
        fileData: null,
        filename: null
      },
      disableButton: true
    };
  },
  computed: {
    filename: function() {
      if (this.fileData.filename === null) {
        return "";
      }
      return this.fileData.filename;
    },
    everythingLoaded: function() {
      return !this.disableButton;
    }
  },
  watch: {
    fileData() {
      this.disableButton = false;
      // this.$emit("input", this.fileData);
    }
  },
  methods: {
    uploadDocument() {
      this.disableButton = true;
      this.$http
        .post(
          this.$apiBaseUrl +
            "user/" +
            this.$route.params.id +
            "/file/" +
            this.fieldId,
          Object.assign({
            fileData: this.fileData.fileData,
            filename: this.fileData.filename
          })
        )
        .then(
          response => {
            this.$emit("input", this.fileData);
            this.fileData.fileData = null;
            this.fileData.filename = null;
            this.disableButton = false;
            this.notifyVue(
              "Chauffeur document succesvol opgeslagen",
              "check",
              "success",
              5000
            );
          },
          response => {
            this.disableButton = false;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur document",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
div.upload-container {
  margin-left: auto;
  max-width: 192px;
}
</style>
